export default "__VITE_ASSET__XHua6UJdp9t4k2f011Vhog__"